
import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { productStartDeleted, productStartUpdate } from '../../../../actions/products'
import { ProductCardStock } from './ProductCardStock'

export const ModalUpdate = ({item,closeModal}) => {
  
    const dispatch = useDispatch()
    const [destacado, setDestacado] = useState(item.destacado)
    const initialState = {
        ...item  
    }
    useEffect(() => {
        console.log(destacado)
              setFormValues( {
                  ...formValues, 
                  destacado
              })
      
        
         
       }, [destacado])
    const [formValues, setFormValues] = useState(initialState)  

    const {precio,cantidad,oferta} = formValues

    const handleInputChange = ({target}) => {

        setFormValues({
            ...formValues,
            
            [target.name]: target.value
        })
        }
    
    const handleSubmitForm = (e) =>{
        e.preventDefault()
        
        setFormValues({
            ...formValues,
            destacado
        })
    
    dispatch(productStartUpdate(formValues));

    Swal.fire({
        position: 'center',
        icon: 'success',
        title: 'Producto actualizado',
        showConfirmButton: false,
        timer: 1500
      })


        closeModal()
    }

    const handleDelete = () =>{
        
        Swal.fire({
            title: 'Quieres eliminar este producto?',
            icon: 'warning',
            showDenyButton: true,
            // showCancelButton: true,
            confirmButtonText: 'Eliminar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                dispatch(productStartDeleted(item))
                Swal.fire({
                    position: 'center',
                    icon: 'success',
                    title: 'Producto Eliminado',
                    showConfirmButton: false,
                    timer: 1500
                  })
              closeModal()
            } else if (result.isDenied) {
                Swal.fire({
                    position: 'center',
                    icon: 'info',
                    title: 'El producto NO ah sido eliminado',
                    showConfirmButton: false,
                    timer: 1000
                  })
            }
          })

    }
    return (

            <form 
                    className="container _modal-form row"
                    onSubmit={ handleSubmitForm }
            >
                 <h5>Actualizar Producto</h5>

                 <div className="_productCardStock ">

                     <ProductCardStock key={item.id} item={item} />
                 </div>

                 <div className='input-cont row mt-2 '>

                    <label htmlFor="precio" className='col-6'>Precio AR$</label>
                    <input 
                        id='precio'
                        type="number" 
                        className="col-5"
                        placeholder={item.precio}
                        min="0" 
                        name="precio"
                        autoComplete="off"
                        value={precio}
                        onChange={ handleInputChange }
                        required
                    />
                 </div>

                 <div className='input-cont row mt-2'>

                    <label htmlFor="cantidad" className='col-6'>Cantidad</label>
                    <input 
                        id='cantidad'
                        type="number" 
                        className="col-5"
                        placeholder={item.cantidad}
                        min="1"
                        name="cantidad"
                        autoComplete="off"
                        value={cantidad}
                        onChange={ handleInputChange }
                        required
                        
                    />
                 </div>

                 <div className='input-cont row mt-2'>

                    <label htmlFor="oferta" className='col-6'>Oferta %</label>
                    <input 
                        id='oferta'
                        type="number" 
                        className="col-5"
                        placeholder="oferta"
                        min="0" 
                        name="oferta"
                        autoComplete="off"
                        value={oferta}
                        onChange={ handleInputChange }   
                    />
                 </div>

                 <div className='checkbox mt-2'>
                    <label htmlFor="destacado"> Producto destacado</label>
                    {destacado&&
                        
                        <input type="checkbox" id="destacado" checked onChange={ (e)=>setDestacado(e.target.checked)}  />
                        }
                        {!destacado&&
                        
                        <input type="checkbox" id="destacado" onChange={ (e)=>setDestacado(e.target.checked)}  />
                        }
                 </div>

                    <div className='row mt-3'>

                            
                                <button
                                    type="submit"
                                    className="btn_blue col-6"
                                >
                            
                                    <span> Actualizar</span>
                                </button>

                                <div
                                          className="btn_red col-6 "
                                          onClick={handleDelete}
                                >
                            
                                    <span> Eliminar</span>
                                </div>
                                               
                        
                    </div>
            </form>
    
    )
}